/* global axios */
import ApiClient from './ApiClient';

class ConversationFinishedReportsAPI extends ApiClient {
  constructor() {
    super('conversation_finished_reports', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  getSummary(params) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getDetailed(params) {
    return axios.get(`${this.url}/detailed`, { params });
  }

  downloadSummaryReport(params) {
    return axios.get(`${this.url}/summary_csv`, {
      params,
      responseType: 'blob',
    });
  }

  downloadDetailedReport(params) {
    return axios.get(`${this.url}/agents`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new ConversationFinishedReportsAPI();
